<template>
  <div class="loyalty-icon-wrapper cell">
    <img v-if="ppcIconName" :src="ppcIconName" :class="iconClass" alt="loyalty membership tier icon" data-testid="icon" />
  </div>
</template>
<script setup>
import { usePpc } from '../composables/usePPC';

defineProps({
  iconClass: {
    type: String,
    default: '',
  },
});

const { ppcIconName } = usePpc();
</script>
<style scoped lang="scss">
@import '~settingSCSS';
.loyalty-icon-wrapper {
  max-width: 24px;
  max-height: 24px;
  @include margin-direction('right', 1.5);
  // mcom only
  .star-rewards-icon {
    display: flex;
    flex-shrink: 0;
  }
}
</style>
